import { readSettingsNumber } from '@/utils'
import { isNull, isUndefined } from 'lodash'
import { computed, ref, watch, type Ref } from 'vue'

export function useCreateSwapOrdersSettings(settingsForm: Ref, cacheKeyPostfix: Ref<string>) {
  const leverage = computed(() =>
    readSettingsNumber(
      settingsForm.value?.states?.leverage?.value,
      leverageCacheKey.value,
      initing.value,
    ),
  )

  const slippage = computed(() =>
    readSettingsNumber(
      settingsForm.value?.states?.slippage?.value,
      slippageCacheKey.value,
      initing.value,
    ),
  )

  const amount = computed(() =>
    readSettingsNumber(
      settingsForm.value?.states?.amount?.value,
      amountCacheKey.value,
      initing.value,
    ),
  )

  const marginMode = computed(() => {
    const value = settingsForm.value?.states?.marginMode?.value
    if (isUndefined(value)) {
      return localStorage.getItem(marginModeCacheKey.value) ?? 'isolated'
    } else {
      return value
    }
  })

  const initing = ref(true)
  const leverageCacheKey = computed(() => `leverage/${cacheKeyPostfix.value}`)
  const marginModeCacheKey = computed(() => `margin-mode/${cacheKeyPostfix.value}`)
  const slippageCacheKey = computed(() => `slippage/${cacheKeyPostfix.value}`)
  const amountCacheKey = computed(() => `amount/${cacheKeyPostfix.value}`)

  watch(leverage, (v) => {
    if (!isNull(v) && !isUndefined(v)) {
      localStorage.setItem(leverageCacheKey.value, v.toString())
    }
  })
  watch(slippage, (v) => {
    if (!isNull(v) && !isUndefined(v)) {
      localStorage.setItem(slippageCacheKey.value, v.toString())
    }
  })
  watch(amount, (v) => {
    if (isNull(v)) {
      localStorage.removeItem(amountCacheKey.value)
    } else if (!isNull(v) && !isUndefined(v) && !isNaN(v)) {
      console.log(v)
      localStorage.setItem(amountCacheKey.value, v.toString())
    }
  })
  watch(marginMode, (v) => {
    if (!isNull(v) && !isUndefined(v)) {
      localStorage.setItem(marginModeCacheKey.value, v)
    }
  })

  const initSettingsForm = (recommendedAmount: number | null) => {
    initing.value = true
    settingsForm.value?.setFieldValue('slippage', slippage.value ?? '1')
    settingsForm.value?.setFieldValue('amount', amount.value ?? recommendedAmount)
    settingsForm.value?.setFieldValue('leverage', leverage.value ?? '1')
    settingsForm.value?.setFieldValue('marginMode', marginMode.value ?? 'isolated')
    initing.value = false
  }

  return {
    initSettingsForm,
    leverage,
    slippage,
    amount,
    marginMode,
    leverageCacheKey,
    marginModeCacheKey,
    amountCacheKey,
    slippageCacheKey,
  }
}
